<template lang="html">
  <div class="card" ref="hot" :style="selfStyle">
    <div class="card-body">
      <slot name="name" />
      <slot name="content" />
      <DynamicItem @click="goDetails" @updateItem="(reload) => updateItem(item, reload)" v-for="item of tops" :key="`tops${item.id}`" v-bind="item" />
      <DynamicItem :videoPlay="videoPlay" @click="goDetails" @updateItem="(reload) => updateItem(item, reload)" v-for="(item, index) of dynamic" :key="`dynamic${index}${item.id}`" v-bind="item"/>
    </div>
    <button @click="queryMore" v-if="count > dynamic.length" class="queryMore">查看更多</button>
    <!-- <transition name="bounce">
       <div  v-if="loading" :style="{'padding-bottom': isAndroid ? 0 : '50px' }" class="loading">加载过程中</div>
      </transition> -->
    <Loading :loading="false"/>
  </div>
</template>

<script>
import { get } from '../utils/request'
import Loading from './Loading.vue'
import { createNamespacedHelpers } from 'vuex'
import DynamicItem from '../components/DynamicItem'
import { isAndroid } from '../utils/utils'
import { set, get as getUser, remove } from '../utils/token'
const { mapGetters } = createNamespacedHelpers('refresh')
export default {
  props: {
    selfStyle: {
      type: String,
      default: ''
    }
  },
  components: {
    Loading,
    DynamicItem
  },
  // async activated () {
  //   this.tops.length = 0
  //   await this.getTops()
  //   this.$nextTick(() => {
  //     this.el = this.$parent.$refs.find
  //   })
  //   this.dynamic.length = 0
  //   this.count = 0
  //   this.page = 1
  //   this.getDynamic()
  // },
  data () {
    return {
      loading: false,
      finished: false,
      isAndroid: isAndroid(),
      dynamic: [],
      tops: [],
      count: 0,
      page: 1,
      el: null,
      size: 10,
      videoPlay: [] // 存储当前播放的video
    }
  },
  async mounted () {
    this.$bus.$on('UPDynamicDetail', this.UPDynamicDetail)
    this.$bus.$on('isVideoPlay', this.isVideoPlay)
    this.tops.length = 0
    await this.getTops()
    this.$nextTick(() => {
      this.el = this.$parent.$refs.find
    })
    this.dynamic.length = 0
    this.count = 0
    this.page = 1
    this.size = this.getFindListCount
    await this.getDynamic()
    setTimeout(() => {
      this.$parent.$refs.find.scrollTop = this.getBrowseCoordFindScroll
    }, 1000)
  },
  computed: {
    ...mapGetters({
      getDownRefresh: 'getDownRefresh'
    }),
    getFindListCount () {
      return this.$store.getters['BrowseCoord/getFindListCount']
    },
    getBrowseCoordFindScroll () {
      return this.$store.getters['BrowseCoord/getBrowseCoordFindScroll']
    }
  },
  methods: {
    // 该事件为控制列表页的视频同时只能播放一个
    isVideoPlay (id, isPlay) {
      const { videoPlay } = this
      if (videoPlay.length === 0) {
        if (isPlay) {
          this.videoPlay[0] = id
        }
      } else {
        if (videoPlay[0] === id) {
          if (!isPlay) {
            this.videoPlay = []
          }
        }
      }
    },
    // 详情页被修改之后更新相应的列表data数据
    // 注册一个全局事件在详情页被修改时调用
    UPDynamicDetail (id) {
      const that = this
      // console.log('动态', id)
      const user = getUser('user')
      setTimeout(() => {
        const promiseMessage = get({
          url: `/circle/commentTree/${id}/${user.id}`
        })
        promiseMessage.then(res => {
          const {
            data: { code, detail }
          } = res
          if (Object.is(code, 200)) {
            detail.forEach(item => {
              item.nid = item.id
              item.createTime = item.crateTime
              item.user = {
                avatar: item.avatar,
                fullname: item.fullname,
                id: item.user__id,
                nickName: item.nickName,
                real_avatar: item.real_avatar
              }
            })
            that.dynamic.forEach(item => {
              if (+item.id === +id) {
                item.comment_list = detail
              }
            })
          }
        })
      }, 500)
    },
    scrollLocation () {
      this.$nextTick(() => {
        const scrollTop = getUser('scrollFind')
        if (scrollTop) {
          this.$parent.$refs.find.scrollTop = scrollTop
          remove('scrollFind')
        }
      })
    },
    goDetails () {
      set('scrollFind', this.$parent.$refs.find.scrollTop)
    },
    getTops () {
      const user = getUser('user')
      if (!user) {
        return
      }
      const promise = get({
        url: `/circle/getRecommendCircle?user=${user.id}`
      })
      promise.then(res => {
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          this.tops = detail
        }
      })
    },
    updateItem (item, reload) {
      // console.log('触发这里')
      Object.assign(item, reload)
    },
    queryMore () {
      const { count, dynamic, page } = this
      if (count > dynamic.length) {
        this.page = page + 1
        this.getDynamic()
      } else {
        this.finished = true
      }
    },
    getDynamic (callback) {
      const user = getUser('user')
      if (!user) {
        return
      }
      if (this.finished) {
        return
      }
      this.loading = true
      const promise = get({
        url: `/circle/topView?page=${this.page}&size=${this.size}&user=${user.id}&visible_range=common`
      })
      promise.then(res => {
        const { data: { code, detail: { count, data } } } = res
        if (Object.is(code, 200)) {
          this.count = count
          this.dynamic = [...this.dynamic, ...data]
          this.loading = false
          this.siae = 10
          this.$store.dispatch('BrowseCoord/setFindListCount', this.dynamic.length)
          if (callback) {
            callback()
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/font/iconfont.css';
.label {
  height: 16px;
  line-height: 16px;
  padding: 0 5px;
  margin-right: 10px;
  font-size: 12px;
  border: 1px solid #FF5722;
  background: none;
  color: #FF5722;
}
.card {
  box-sizing: border-box;
  background: transparent;
  // background-color: #f5f5f5;
  padding: 0 7.5px;
  margin-bottom: 15px;
  width: 100%;
  border-radius: 2px;
  .card-body {
    background-color: #f5f5f5;
    .card-header {
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      border-bottom: 1px dotted #E9E9E9;
      color: #333;
      border-radius: 2px 2px 0 0;
      font-size: 14px;
    }
  }
  .queryMore {
    width:132px;
    height:44px;
    background:rgba(245,245,245,1);
    border-radius:4px;
    margin: 12px auto 0;
    border: none;
    outline: none;
    display: block;
  }
}
@media screen and (max-width: 768px) {
  .card {
    padding:0 7.5px !important;
  }
}
</style>
